import Box from '@mui/material/Box';
import { useState } from 'react';

import { FileDropZone } from '@/components/form/FileDropZone';

import { State } from '../State';

const ACCEPT = 'application/pdf,image/png,image/jpeg';
const HINT = 'PDF, PNG or JPEG, up to 25 MB.';

/** A file to show without reading one from disk. */
const SAMPLE_FILE = new File([new Uint8Array(1_887_436)], 'Medication Abortion FAQ.pdf', {
  type: 'application/pdf',
});

export function FileDropZoneExamples() {
  const [chosen, setChosen] = useState<File | null>(null);
  const [refused, setRefused] = useState<string | null>(null);

  return (
    <>
      <State
        title="Empty"
        note="Drop a file or choose one; nothing leaves the browser. A file that is not a PDF is refused."
      >
        <Box sx={{ maxWidth: 480 }}>
          <FileDropZone
            label="Document file"
            hint={HINT}
            accept={ACCEPT}
            value={chosen}
            onChange={(file) => {
              if (file.type !== 'application/pdf') {
                setRefused('Choose a PDF, PNG or JPEG file.');
                return;
              }
              setRefused(null);
              setChosen(file);
            }}
            onRemove={() => setChosen(null)}
            error={refused}
            testId="gallery-file-drop-zone-empty"
          />
        </Box>
      </State>

      <State title="With a file">
        <Box sx={{ maxWidth: 480 }}>
          <FileDropZone
            label="Document file"
            hint={HINT}
            accept={ACCEPT}
            value={SAMPLE_FILE}
            onChange={() => undefined}
            onRemove={() => undefined}
            testId="gallery-file-drop-zone-with-file"
          />
        </Box>
      </State>

      <State
        title="Busy"
        note="While the file is being sent: the bar shows and the controls wait."
      >
        <Box sx={{ maxWidth: 480 }}>
          <FileDropZone
            label="Document file"
            hint={HINT}
            accept={ACCEPT}
            value={SAMPLE_FILE}
            onChange={() => undefined}
            onRemove={() => undefined}
            busy
            busyMessage="Uploading Medication Abortion FAQ.pdf"
            testId="gallery-file-drop-zone-busy"
          />
        </Box>
      </State>

      <State
        title="Disabled with a reason"
        note="Before the upload rules have been read from the server."
      >
        <Box sx={{ maxWidth: 480 }}>
          <FileDropZone
            label="Document file"
            hint={HINT}
            accept={ACCEPT}
            value={null}
            onChange={() => undefined}
            onRemove={() => undefined}
            disabled
            disabledReason="The upload rules are still loading."
            testId="gallery-file-drop-zone-disabled"
          />
        </Box>
      </State>
    </>
  );
}
